import {
  Box,
  Button,
  Heading,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { tradingNameParser } from "src/lib/utils";

const ClaimPage = () => {
  const router = useRouter();
  const { name, voltwise_id, email } = router.query;
  const [loading, setLoading] = useState(true);
  const [claimLoading, setClaimLoading] = useState(false);
  const [claimError, setClaimError] = useState(null);

  const handleClick = (voltwise_id: string) => {
    setClaimLoading(true);
    fetch("/api/claim", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        voltwise_id: voltwise_id,
      }),
    }).then((res) => {
      if (res.ok) {
        router.push("/claim-success?email=" + email);
      } else {
        setClaimError(true);
        setClaimLoading(false);
      }
    });
  };

  useEffect(() => {
    if (name) {
      setLoading(false);
    } else {
      // Handle the case where the name is not found
      setLoading(false);
    }
  }, [name]);

  return (
    <>
      {!loading && name && (
        <Box
          bg={"white"}
          borderWidth="1px"
          p={8}
          borderRadius={4}
          mb={8}
          maxWidth={"600px"}
          ml={"auto"}
          mr={"auto"}
        >
          <Heading as={"h1"} mt={6} color="#0B3948" size="lg">
            {tradingNameParser(name)}
          </Heading>
          <Text mt={"20px"}>By claiming this page, you will be able to:</Text>
          <UnorderedList>
            <ListItem>Edit your company information</ListItem>
            <ListItem>
              Showcase your services with case studies of successful projects
            </ListItem>
            <ListItem>Capture more customer interest</ListItem>
          </UnorderedList>
          This service is currently free during the test phase but will have a
          small fee in the future to cover our costs.
          <br />
          <br />
          <br />
          <Button
            colorScheme="green"
            isLoading={claimLoading}
            onClick={() => handleClick(voltwise_id as string)}
          >
            Claim Profile
          </Button>
          {claimError && (
            <Text color={"red"} mt={4}>
              Something went wrong. Please try again later.
            </Text>
          )}
        </Box>
      )}
    </>
  );
};

export default ClaimPage;
